import React from 'react';
import loading from '../assets/loading.webp';

export default function Loading() {
  return (
    <img src={loading} alt='loading...' style={{ objectFit: 'contain', maxHeight: "100%", maxWidth: "100%" }} />
  );
}